"use client";

import { useEffect } from "react";
import s from "./style.module.scss";
import { VideoContainer } from "../../VideoContainer/VideoContainer";
import glideImage from "../../../utils/useGlideImage.ts";

export type BoxProps = {
  imagePlacement: "right" | "left";
  title: string;
  description: string;
  assetType?: string;
  r2BucketUrl?: string;
  img: {
    src: string;
    alt: string;
  };
  percents: {
    number: string;
    text: string;
  };
  isVideo?: boolean;
  videoId?: string;
};

export const Box = ({
  imagePlacement = "right",
  title,
  description,
  img,
  percents,
  isVideo,
  videoId,
  assetType,
  r2BucketUrl,
}: BoxProps) => {
  const scrollToAshwaghanda = () => {
    document
      .getElementById("ashwaghanda")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const buttons = document.querySelectorAll(".scroll-button");

    buttons.forEach((button) => {
      button.addEventListener("click", scrollToAshwaghanda);
    });

    return () => {
      buttons.forEach((button) => {
        button.removeEventListener("click", scrollToAshwaghanda);
      });
    };
  }, []);

  return (
    <div className={s.box}>
      <div className={s.box__left}>
        <h3 className={s.box__title}>{title}</h3>
        <div
          className={s.box__description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div>
          <div className={s.box__labelContainer}>
            <span className={s.box__percentage}>{percents.number}</span>
            <span className={s.box__label}>{percents.text}</span>
          </div>
          <div>
            <div className={s.box__progressBar}>
              <div
                className={s.box__progressBarFill}
                style={{ width: percents.number }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${s.box__right} ${
          imagePlacement === "right" ? s.box__imgRight : s.box__imgLeft
        }`}
      >
        {isVideo && (videoId || r2BucketUrl) ? (
          <VideoContainer
            videoId={videoId}
            r2BucketUrl={r2BucketUrl}
            assetType={assetType ?? "iframe"}
            className={s.box__video}
          />
        ) : (
          <img
            src={glideImage(img.src, { w: 552, h: 360 })}
            alt={img.alt}
            width={552}
            height={360}
          />
        )}
      </div>
    </div>
  );
};
